<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
  <h6 class="modal-title mb-0">Admin : FlashCard Management : Shuffling</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 headersize py-2">
    <span class="px-4 my-2 path-class"> {{path}}</span>
  </div>
</div>
<hr class="mt-0"/>
<div class="modal-body m-body pt-0 px-0" >
  <!-- Apply cdkDropListAutoScroll to the parent container -->
  <div #dropListContainer
  style="height: 80vh; overflow-y: auto;"
  class="example-container"
  cdkDropListAutoScroll
  cdkDropListGroup>
    <div
      *ngFor="let item of FlashCards; let i = index"
      cdkDropList
      [cdkDropListData]="i"
      class="w-49"
    >

      <div
        cdkDrag
        [cdkDragData]="i"
        (cdkDragEntered)="dragEntered($event)"
        (cdkDragMoved)="dragMoved($event)"
        (cdkDragDropped)="dragDropped($event)"
        class="example-box"
        [ngStyle]="{ 'background-color': isHighlighted(i) ? '#ed7c31' : '#2E77AE' }"
      >
      <div class="row h-100 w-100 position-relative ">
        <span *ngIf="item.Display_Order"   class="text-white" style="top:-32px; color:white; z-index:9999" class="position-absolute text-end" >
          <i class="fa fa-pencil-square-o pointer-cursor"  aria-hidden="true"(click)="triggerParentFunction(item)"></i>
          {{item.Display_Order}}
        </span>
        <span *ngIf="item.Flashcard_Status_Type_Name"   class="text-white" style="top:-32px; color:white;" class="position-absolute " >{{item.Flashcard_Status_Type_Name}}
        </span>

    <h3 class="text-white position-absolute text-center"
        style="top:-32px"
    >{{item.FlashCard_ID}}</h3>

        <div class="col-md-6 px-0 h-100">
          <div class="w-100 h-100 rounded border-end text-wrap bg-white overflow-auto p-2" style="zoom: 55%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(item.Front_Side_Text ??'')">
          </div>
          <div class="row mt-2">
            <div class="col-12  text-white fs-7 d-flex justify-content-between">
              <span>Created By : {{item.Created_By}} ({{ item.Creation_Date | date: 'short' }})</span>
            </div>

          </div>
        </div>
        <div class="col-md-6 px-0 h-100">
          <div class="w-100 h-100 rounded border-end text-wrap bg-white overflow-auto p-2" style="zoom: 55%; position:relative; top:10px" [innerHTML]="this.SanitizeHTML(item.Back_Side_Text??'')">
          </div>

            <div class="row mt-2">
              <div class="col-12 text-white fs-7 ps-4  d-flex justify-content-between">
                <span>Updated By: {{item.Updated_By}} ({{item.Updation_Date | date :'short'}})</span>

              </div>
            </div>
        </div>
      </div>
        <!-- <small>{{ item.FlashCard_ID }}</small> -->
      </div>
    </div>
  </div>

</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button
    type="button"
    class="bl-btn btn btn-sm px-3"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border px-3"
    (click)="onCross()"
  >
    Cancel
  </button>
</div>
